import React from 'react';
import { useAccount } from '@/hooks/useAccount';
import { TabNav } from '@repo/ui/Tabs';
import { NavTab } from '@repo/ui/Tabs';

const SecurityTabNav = () => {
  const currentAccount = useAccount();

  const SecurityTabs: NavTab[] = [
    {
      title: 'IP Whitelist',
      href: `/a/${currentAccount?.id}/account-settings/ip-whitelist`,
    },
    // {
    //   title: 'MFA Enforcement',
    //   href: `/a/${currentAccount?.id}/account-settings/mfa`,
    // },
  ];

  return <TabNav tabs={SecurityTabs} />;
};

export default SecurityTabNav;
